import { render, staticRenderFns } from "./updateMessage.vue?vue&type=template&id=5f96d118&"
import script from "./updateMessage.vue?vue&type=script&lang=js&"
export * from "./updateMessage.vue?vue&type=script&lang=js&"
import style0 from "./updateMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports